import { render } from "./AssetTypeEditImage.vue?vue&type=template&id=5a5b172e"
import script from "./AssetTypeEditImage.vue?vue&type=script&lang=js"
export * from "./AssetTypeEditImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__